export const getRacketTypeFromStorage = () => {
  return sessionStorage.getItem("racketType");
};

export const removeRacketTypeFromStorage = () => {
  sessionStorage.removeItem("racketType");
};

export const setRacketTypeToStorage = (racketType: string) => {
  sessionStorage.setItem("racketType", racketType);
};
